export default "__VITE_ASSET__BgC7vdvT__"